import {Component, EventEmitter, Input, Output} from '@angular/core';

import {MatRipple} from '@angular/material/core';
import {MatCardModule} from '@angular/material/card';
import {MatBadge} from '@angular/material/badge';
import {MatTooltip} from '@angular/material/tooltip';
import {TranslatePipe} from '@ngx-translate/core';
import {Team} from '../../models/HAL/team-hal.model';
import {TeamIconComponent} from '../team-icon/team-icon.component';

@Component({
  selector: 'app-team-card',
  imports: [
    MatCardModule,
    MatBadge,
    MatTooltip,
    MatRipple,
    TranslatePipe,
    TeamIconComponent
  ],
  templateUrl: './team-card.component.html',
  styleUrl: './team-card.component.scss'
})
export class TeamCardComponent {
  @Input({required: true}) team!: Team;
  @Output() readonly selectTeam = new EventEmitter<Team>();

  onSelect(): void {
    this.selectTeam.emit(this.team);
  }
}
